'use client';
import React, { useState } from 'react';
import { Plus, Package } from 'lucide-react';
import { toast } from 'sonner';
import StorageMeter from '@/components/ui/StorageMeter';

const STORAGE_PACKS = [
  { id: 'pack-001', purchased: 'June 22, 2026', expires: 'June 22, 2027', photos: 100, price: '$19.95' },
];

export default function BillingStorageSection() {
  const [purchasing, setPurchasing] = useState(false);

  const handleAddPack = async () => {
    setPurchasing(true);
    await new Promise(r => setTimeout(r, 1000));
    setPurchasing(false);
    toast?.success('Storage Pack added! +100 photos available.');
    // Backend integration point: create Stripe checkout session for Storage Pack
  };

  return (
    <div className="space-y-4">
      {/* Storage meter card */}
      <div className="bg-card border border-border rounded-2xl shadow-card p-5">
        <h3 className="font-700 text-sm text-foreground mb-4">Photo Storage</h3>
        {/* Backend integration point: fetch actual storage usage */}
        <StorageMeter used={94} total={100} showUpgrade={false} />

        <div className="mt-4 pt-4 border-t border-border space-y-2">
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Base (Premium)</span>
            <span className="font-600 text-foreground font-tabular">100 photos</span>
          </div>
          {STORAGE_PACKS?.map((pack) => (
            <div key={pack?.id} className="flex items-center justify-between text-xs">
              <span className="text-muted-foreground">Storage Pack × 1</span>
              <span className="font-600 text-foreground font-tabular">+100 photos</span>
            </div>
          ))}
          <div className="flex items-center justify-between text-xs pt-2 border-t border-border">
            <span className="font-700 text-foreground">Total Capacity</span>
            <span className="font-800 text-foreground font-tabular">200 photos</span>
          </div>
        </div>
      </div>
      {/* Storage pack purchase */}
      <div className="bg-card border border-border rounded-2xl shadow-card p-5">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center shrink-0">
            <Package size={18} className="text-accent" />
          </div>
          <div>
            <p className="font-700 text-sm text-foreground">Add Storage Pack</p>
            <p className="text-xs text-muted-foreground mt-0.5">+100 photos · $19.95/year</p>
          </div>
        </div>
        <p className="text-xs text-muted-foreground mb-4 leading-relaxed">
          Storage packs can be purchased multiple times. Each pack adds 100 photos and renews annually.
        </p>
        <button
          onClick={handleAddPack}
          disabled={purchasing}
          className="paw-btn w-full flex items-center justify-center gap-2 py-2.5 bg-accent text-white rounded-xl text-sm font-700 hover:bg-warning transition-all disabled:opacity-60"
        >
          {purchasing ? (
            <><span className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />Processing...</>
          ) : (
            <><Plus size={15} />Add 100 Photos — $19.95/yr</>
          )}
        </button>
      </div>
      {/* Active storage packs */}
      {STORAGE_PACKS?.length > 0 && (
        <div className="bg-card border border-border rounded-2xl shadow-card p-5">
          <p className="text-xs font-700 text-muted-foreground uppercase tracking-wider mb-3">Active Storage Packs</p>
          {STORAGE_PACKS?.map((pack) => (
            <div key={pack?.id} className="flex items-center justify-between py-2.5 border-b border-border last:border-0">
              <div>
                <p className="text-sm font-600 text-foreground">+{pack?.photos} Photos</p>
                <p className="text-xs text-muted-foreground">Purchased {pack?.purchased}</p>
              </div>
              <div className="text-right">
                <p className="text-xs font-600 text-foreground">{pack?.price}/yr</p>
                <p className="text-xs text-muted-foreground">Expires {pack?.expires}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}